import { takeLatest } from 'redux-saga/effects';

import {
  ON_BETA_DASHBOARD_MOUNT,
  ON_BETA_DASHBOARD_MOUNT_ERROR,
  ON_BETA_DASHBOARD_TIME_FILTER_CHANGE
} from '../actions';

import { onDashboardMount, getAccountReportForTimeFrame } from './sagas';
import { redirectToHomepage } from '../../dashboard/actions/sagas';

export function* onBetaDashboardMount() {
  yield takeLatest(ON_BETA_DASHBOARD_MOUNT, onDashboardMount);
}

export function* redirectToHomepageOnBetaMountError() {
  yield takeLatest(ON_BETA_DASHBOARD_MOUNT_ERROR, redirectToHomepage);
}

export function* fetchAccountReportOnTimeFilterChangeBeta() {
  yield takeLatest(ON_BETA_DASHBOARD_TIME_FILTER_CHANGE, getAccountReportForTimeFrame);
}



// WEBPACK FOOTER //
// ./src/modules/beta-dashboard/actions/watchers.js